"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var Command=function(){function t(t,e,n,a){this.success=!0,Object.assign(this,{callback:t,listenerId:n,param:e,next:a});try{this.respond()}catch(t){this.invokeCallback(null)}}return t.prototype.invokeCallback=function(t){var e=null!==t;"function"==typeof this.next?this.callback(this.next,t,e):this.callback(t,e)},t}();exports.Command=Command;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@iabtcf/cmpapi/lib/command/Command.js
// module id = 11
// module chunks = 0